export const en = {
    dashboard: {
        tabs: {
            home: "Home",
            watch: "watch",
            evaluate: "evaluate",
            history: "history",
            favorite: "favorite"
        },
        watchSection: {
            courses: {
                title: "Courses"
            },
            series: {
                title: "Series",
                lockMsg: "Series is locked",
                timelineUnlockBanner:
                    "Complete required steps in Timeline to unlock the Series",
            },
            subscription: {
                active: "Active",
                inactive: "Inactive",
                expiresOn: "Expires on",
            },
            empty: {
                subscriptionTitle: "No Active Subscription",
                subscriptionSubtitle: "Unlock access to all the Masterclasses videos - all at once - at a affordable subscription price!",
                subscriptionCta: "Check out",
                coursesTitle: "No Courses Found",
                coursesSubtitle: "Enroll in new courses to continue learning",
                coursesCta: "Check out",
                seriesTitle: "No Series Found",
                seriesSubtitle: "Enroll in new courses to continue learning",
                seriesCta: "Check out",
                studyResourcesTitle: "No Resources Found",
                studyResourcesSubtitle: "There are no study materials found yet. Check back later for resources.",
                noticesTitle: "No notices found",
                noticesSubtitle: "",
                evaluationTitle: "No Exams Found",
                evaluationSubtitle: "There are no evaluation exams found at the moment. Complete your courses to unlock exams.",
            },
        },
        evaluateSection: {
            exam: {
                title: "Exam(s)",
                whenNoExam: "Nothing to see here",
                examIsLocked: "Exam is locked",
                passed: "Passed",
                failed: "Failed",
                whenResultWillCome: "Detailed result available in",
                viewResultBtn: "View result",
                reAttemptBtn: "Re-attempt",
                okBtn: "OK",
                payBtn: "Pay",
                notice: "Notice",
                reAttemptModal: {
                    one: "Before you proceed, please take a moment to read and acknowledge the following:",
                    two: "You have",
                    three_one: "two free attempts",
                    three_two: "only one attempt left",
                    four: "for this exam",
                    five: "Any additional attempts beyond the initial two may incur additional charges",
                    six: "By clicking",
                    seven: "OK",
                    eight: "below, you agree that you are aware of these terms and conditions.",
                    nine: "‼️You’ve used your 2 free attempts.",
                    ten: "To try again, you will need to",
                    eleven: "pay Rs. 200 for an additional attempt."
                }
            },
            test: {
                title: "Test(s)",
                whenNoTest: "Nothing to see here"
            }
        },
        historySection: {
            noVideoText: "Videos you watched will be saved in history"
        },
        favVideosSection: {
            noVideoText: "No videos added to favourites yet"
        }
    },
    timeline: {
        heading: "timeline",
        courseCardHeading: "Course Details",
        underProgress: "Under progress",
        freeAccess: "Free Access",
        enrolled: "Enrolled",
        verify: "Verify",
        watch: "Watch",
        exam: "Exam",
        certificate: "Certificate",
        submitSectionHeading: "Submit",
        examUnLockCard: {
            p1: "Exam is Now Unlocked",
            p2: "Exam is unlocked. You can finish it now.",
            p3: "Exam failed",
            p4: "Unfortunately, you did not pass the exam. Please reattempt.",
        },
        enrolledSection: {
            summary: "Summary",
            amountPaid: "Amount Paid",
            minimumAmountPayable: "Minimum Amount Payable",
            minimumBalance: "Minimum Balance",
            invoices: "INVOICE(S)",
            payBalance: "Pay Balance",
            payFullBalance: "Pay full balance",
            noAdditionalCharge: "+ No additional charge",
            charges: "Charges",
            pay: "Pay",
            payBefore: "Pay Before",
            installment: "Installment",
            popUpInfo: "If payment date is missed, access to Video Series, Exam and Certificate can be revoked.",
            popUpWarning1: "Payment date is missed!",
            popUpWarning1_1: "Complete payment immediately to restore access to Video Series, Exam and Certificate."
        },
        verifySection: {
            basicDetails: "Basic details",
            legalInformation: "Legal Information",
            deliveryAddress: "Delivery Address",
            verification: "Verification",
            bss: "BSS",
            reSubmit: "Please re-submit the following:",
            ineligibleText: "You are ineligible for certificate"
        },
        watchSection: {
            startCourse: "Start Course",
            iWillStartLater: "I will start later",
            popUp1: {
                p1: "The course duration starts counting from the 'Start Course' date.",
                p2: "Do you want to start now?",
                p3: "Your course has started. All the best with your learning!",
                b1: "Yes, Start Now"
            },
            popUp2: {
                p1: "When do you want to start the course?",
                p2: "We will notify you to start the course on this date",
                p3: "Notification to start course later is set!"
            },
            dateErr: "Please select the date"
        },
        examSection: {
            ineligibleText: "You are ineligible to give this exam"
        },
        submitSection: {
            p1: "No objection certificate"
        },
        certificateSection: {
            inEligibleNotice: {
                h1: "Ineligible! 🤔",
                p1: "Your current qualification doesn’t allow you to get this certificate"
            },
            paymentPendingNotice: {
                h1: "Finish payment! 🤔",
                p1: 'Complete the payment to unlock certificate '
            },
            verificationPending: {
                h1: "Verification pending! 🤔",
                p1: "Your documents have not been checked by the our team yet. Please wait or"
            },
            examPending: {
                h1: "Finish exam! 🤔",
                p1: 'Complete the final examination to unlock certificate'
            },
            extendDuration: {
                h1: "Minimum course duration not met 🔒",
                p1: "Certificate is eligible if the course is done for a minimum duration Check product page for Minimum Certificate Duration"
            },
            nocVerificationPending: {
                h1: "NOC Verification Pending! 🤔",
                p1: "Your documents have not been checked by the our team yet. Please wait or Contact Support"
            },
            certificateReady: {
                h1: "Congratulations! 🎉",
                p1: "You have successfully completed the course"
            },
            certificateClaimed: {
                h1: "Certificate claimed! 🎉",
                p1: "You’re done  ✅ Certificate will be dispatched when ready."
            },
            certificateDispatched: {
                h1: "Dispatched for delivery on",
                p1: "Please click the button below to confirm that you have received your delivery.",
                b1: "I have received the certificate",
                modal: {
                    p1: "First, check if you have got the certificate. Click Confirm only if you have received it."
                }
            },
            deliveryConfirmed: {
                p1: "Certificate delivery confirmed on"
            }
        }
    },
    profile: {
        heading: 'Profile',
        basicDetailsSection: {
            heading: "Basic Details",
            notes: {
                n1: "You can keep the display name to whatever you like as long as it follows our",
                n2: "This will be shown to others",
                n3: "Enter minimum 4 to 15 characters. Only letters, underscore and numbers. No symbols or spaces allowed",
                n4: "Enter the verification code we just sent on your email.",
                n5: "Minimum age 15.",
            },
            whatsAppNoNote: "WhatsApp number is same as Phone Number",
        },
        legalInformationSection: {
            heading: "Legal Information",
            notes: {
                n1: "Enter the name",
                n2: " exactly ",
                n3: "as it appears on government documents. The invoices will be generated based on this information.",
                n4: "I have entered the name correctly abiding by legal requirements",
            },
        },
        addressDetailsSection: {
            heading: "Delivery address",
            notes: {
                n1: "Physical delivery of certificates will be on this address. Please enter the details correctly,",
                n2: " certificates once delivered cannot be returned.",
                n3: "I have entered the details correctly and know certificates will be delivered to this address. I will be liable if wrong address is entered.",
                n4: "Save your changes?",
                n5: "You have unsaved changes. Do you want to save before leaving?",
            },
        },
        identityVerificationSection: {
            heading: "Identity Verification",
            notes: {
                n1: "Please",
                n2: " crop the image to focus on the area where your name appears ",
                n3: "on the certificate.",
                n4: "Enter your name ",
                n5: "exactly ",
                n6: "as it appears on the document. ",
                n7: "DO NOT ",
                n8: "include prefixes like ",
                n9: "Dr or Mr or Mrs. ",
                n10: "It will be later checked by our team for verification. Check for full stops, spacing, etc.",
                n11: "I acknowledge that I have provided correct information and documents."
            },
        },
        bssSection: {
            heading: "B.S.S. (Bharat Sevak Samaj) Requirements",
            notes: {
                n1: [
                    "This information will be used to make your admission form for B.S.S., Chennai, Planning Commission, Govt. of India.",
                    "All details entered here are required by BSS to process your admission.",
                    "Kindly enter correct details"
                ],
                n2: "ENCLOSED DOCUMENTS",
                n3: "This will be sent to BSS for verification purposes.",
                n4: "I here by declare that the entries made above are correct and that they have been made in my own handwriting",
            }
        },
        fields: {
            displayName: "Display Name",
            username: "Username",
            email: "Email",
            otpVerification: "OTP Verification",
            dateOfBirth: "Date of birth",
            whatsAppNumber: "WhatsApp number",
            gender: "Gender",
            legalFirstName: "Legal First Name",
            legalMiddleName: "Legal Middle Name",
            legalLastName: "Legal Last Name",
            flatHouseNumber: "Flat/House/Plot No",
            buildingName: "Building Name",
            colonyName: "Colony Name",
            areaName: "Area Name",
            landmark: "Landmark",
            pincode: "Pincode",
            city: "City",
            state: "State",
            country: "Country",
            guardianName: "Name of the father/guardian",
            guardianContactNumber: "Father’s/Guardian’s Phone Number",
            bloodGroup: "Blood Group",
            underGraduateDegree: "Undergraduate Degree",
            underGraduateInstituteName: "Institute for Undergraduate Degree",
            registrationNumber: "Council Registration Number",
            passingYear: "Year of Passing",
            aadharCard: "Aadhar card",
            panCard: "PAN Card",
            otherDocs: "Other documents",
            signature: "Signature",
            placeOfSignature: "Place of Signature",
            dateOfSignature: "Date of Signature",
            bssAcknowledged: "I here by declare that the entries made above are correct and that they have been made in my own handwriting",
            finishedUndergraduateDegree: "Have you finished your undergraduate degree",
            i: "I....",
            whatAreYouLookingFor: "What are you looking for?",
            whatAreYouLookingFor2: "What are you looking for",
            selectUndergraduateDegree: "Select undergraduate degree",
            marksheetOrDegreeCertificate: "Marksheet/Degree Certificate",
            iDProof: "ID Proof",
            legalPhoto: "Legal Photo",
            nameAsOnMarksheetDegreeCertificate: "Name as on Marksheet/Degree Certificate",
            qualificationNote: "Qualification Note",
            haveYouinishedYourUndergraduateDegree: "Have you finished your undergraduate degree?"
        },
        placeHolders: {
            enterYourName: "Enter your Name",
            enterYourUsername: "Enter your Username",
            enterEmail: "Enter Email",
            fourZeros: "0000",
            whatsAppNumber: "WhatsApp Number",
            selectYourGender: "Select your gender",
            legalFirstName: "Legal First Name",
            legalMiddleName: "Legal Middle Name",
            legalLastName: "Legal Last Name",
            flatHouseNumber: "Enter Flat/House/Plot No",
            buildingName: "Building Name",
            colonyName: "Colony Name",
            areaName: "Area Name",
            landmark: "Landmark",
            pincode: "Pincode",
            city: "City",
            state: "State",
            country: "Country",
            guardianName: "Enter father/guardian name",
            guardianContactNumber: "Phone Number",
            bloodGroup: "Select blood group",
            underGraduateDegree: "Select Undergraduate Degree",
            underGraduateInstituteName: "Enter Name of Institute for Undergraduate Degree",
            underGraduateInstituteAddress: "Enter Address of Institute for Undergraduate Degree",
            registrationNumber: "Registration Number",
            passingYear: "Select Year of Passing",
            aadharCard: "Upload your Aadhar card",
            panCard: "Upload your PAN Card",
            otherDocs: "If the eMediSkill Team has asked you to submit any other document with the Admission Form, you can upload it here. If not, you can skip this.",
            signature: "Signature of the Candidate",
            placeOfSignature: "Place of Signature",
            finishedUndergraduateDegree: "Have you finished your undergraduate degree",
            select: "Select",
            pleaseLetUsKnowWhatKindOfCourseOrLearningOpportunityYouInterestedIn: "Please let us know what kind of course or learning opportunity you’re interested in:",
            pleaseLetUsKnowWhatKindOfCourseOrLearningOpportunityYouInterestedIn2: "Please let us know what kind of course or learning opportunity you’re interested in",
            qualification: "Qualification",
            noteForMarksheet: "Upload your Marksheet/Degree Certificate in JPG, JPEG & PNG only.",
            uploadYourIdProofIssuedByTheGovernment: "Upload your ID Proof issued by the government",
            uploadYourLegalPhoto: "Upload your Legal Photo",
            nameAsOnMarksheetDegreeCertificate: "Enter your as on Marksheet/Degree Certificate",
        }
    },
    videoPlayer: {

    },
    common: {
        status: {
            completed: "Completed",
            actionRequired: "Action required",
            notSubmitted: "Not Submitted",
            ineligible: "Ineligible",
            locked: "Locked"
        },
        statusText: {
            loading: "Loading...",
            completedOn: "Completed on",
            enrolledOn: "Enrolled on",
            endsOn: "Ends on",
            expiredOn: "Expired on",
            remaining: "days remaining",
            verifiedOn: "Verified on",
            submittedOn: "Submitted on",
            cancleBtn: "Cancel",
            confirmBtn: "Confirm",
            setBtn: "Set",
            startExam: "Start Exam",
            reattemptExam: "Reattempt Exam",
            claimYourCertificate: "Claim your certificate",
            claimCertificate: "Claim certificate",
            uploadBtn: "Upload",
            submittedText: "Submitted",
            rejectedText: "Rejected",
            claimedOn: "Claimed On",
            dispatchedOn: "Dispatched On",
            delivered: "Delivered",
            contactSupport: "Contact Support",
            extendDuration: "Extend Duration",
            extendDuration1: "Your access to the series has expired",
            termsOfService: "Terms of Service",
            issueInUpdating: "Issue in updating please refresh the page and try again",
            issueInDownloadingPdf: "Issue in downloading pdf, try again",
            pleaseGiveInput: "Please give input",
            pleaseGiveInput2: "Please make sure all the inputs are filled",
            pleaseGiveInput3: "Please make sure all the required inputs are filled",
            pleaseGiveInput4: "Acknowledgment required to proceed.",
            validationInstruction1: "Please follow the validation instruction",
            inValidEmailWarn: "Please give a valid email address",
            verifyBtn: "Verify",
            verifyingBtn: "Verifying...",
            resendOtpBtn: "Resend OTP",
            sendingOtpBtn: "Sending OTP...",
            resendOtpIn: "Resend in",
            incorrectOtp: "Incorrect OTP",
            issueInOtpVerification: "Issue in OTP Verification try again",
            age15Err: "Minimum age 15 is required",
            male: "male",
            female: "female",
            discardBtn: "Discard",
            saveBtn: "Save",
            savingBtn: "Saving...",
            tapOrClickHereToUploadYourDocument: "Tap or click here to upload your document",
            browseFiles: "Browse files",
            saveAndContinueBtn: "Save and Continue",
            errorUploadingImage: "Error uploading image, please try again",
            saveCropBtn: "Save Crop",
            toastProfileSubmittedSuccessfully: "Profile submitted successfully!",
            submitBtn: "Submit",
            watchedTag: "Watched",
            notWatchedTag: "Not watched",
            studyCheckHeading: "Study check",
            studyCheckDismissAria: "Dismiss study check notice",
            studyCheckP1:
                "A video may be marked as Watched automatically after a few seconds of playback. This is just a system update, it may not always mean you actually completed the lesson.",
            studyCheckP2:
                "Use the Watched button as your Study Check: Only keep it marked Watched if you actively studied (for example, with pen & paper). Mindless watching shouldn’t count toward your progress.",
            watchStatusSection: "Watch status",
            markAsWatchedHint: "Mark as watched",
            markAsNotPlayedHint: "Mark as not played",
            views: "Views",
            readMore: "Read More",
            readLess: "Read Less",
            shareBtn: "Share",
            reportBtn: "Report",
            share: "Share",
            urlCoped: "Shared URL copied!",
            misinformation: "Misinformation",
            missingPresentation: "Missing Presentation",
            other: "Other",
            reportVideo: "Report video",
            reportText: "Multiple reports can be sent for the same video in case of more than one error. In case of technical or editing errors, video gets updated as soon as possible. eMediSkill Team takes cases of misinformation very seriously.",
            viewOurTermsOfService: "View our Terms of Service",
            reportQueryVideo01: "Query reported successfully.",
            reportQueryVideo02: "Issue in reporting please try again",
            comments: "Comments",
            addAComment: "Add a comment...",
            addAReply: "Add a reply...",
            commentBtn: "Comment",
            replyBtn: "Reply",
            replies: "replies",
            module: "Module",
            noCommentYet: "No comment yet",
            addComment: "Add Comment",
            searchVideos: "Search videos",
            noSearchResults: "No search result(s) found",
            searchResultsFound: "search result(s) found",
            recentSearches: "Recent Searches",
            termsAndConditions: "Terms and Conditions",
            privacyPolicy: "Privacy Policy",
            getTheApp: "Get the App",
            aboutUs: "About us",
            contactUs: "Contact Us",
            allRightsReserved: "a sub brand of Intelegent Services FZC, 2025, All rights are reserved",
            extendCourseDuration: "Extend Course(s) Duration",
            extendFor: "Extend for",
            extendNotSelectedError: "Please select the extend duration",
            selectCourseDuration: "Select Course Duration",
            note: "Note",
            proceedToPay: "Proceed to pay",
            days: "days",
            toPay: "To pay",
            processedBy: "Processed by",
            paymentGateway: "Please select the payment gateway",
            additional: "Additional",
            discountOnTotal: "discount on total",
            reviewPayment: "Review Payment",
            total: "Total",
            discount: "discount",
            finalPayableAmount: "Final Payable Amount",
            youAreSaving: "You are saving",
            onThisPurchase: "on this purchase!",
            l1: "Your course has been successfully extended.",
            issueInDownloadingInvoice: "Issue in downloading invoice, please refresh the page and try again",
            issueInFindingPaymentGateway: "Issue with payment gateway, please refresh the page and try again",
            strikesAllowed: "STRIKES ALLOWED:",
            strikesN1: "On the fourth strike exam will automatically get submitted",
            timeRemaining: "TIME REMAINING:",
            noOrderIdFound: "No order id found, please refresh the page and try again",
            extension: "Extension",
            extensionN1: "Enjoy a free course extension for the first time! 😎",
            selectDuration: "Select duration",
            pingCodeErr: "Please put a pin code of 6 digits",
            s1: "Due to security reasons, detailed result will be available in",
            s2: "You are allowed to view the detailed result only once. Please ensure you are not opening it by mistake.",
            proceedBtn: "Proceed",
            s3: "(First time extension free)",
            clickHere:"Click here",
            s4:"to view No objection certificate format",
        }
    },
    dashboard_v1: {
        tabs: {
            courses: "Cursos",
            profile: "Mi Perfil",
            invoices: "Facturas"
        },
        content: {
            courses: "Tus cursos aparecerán aquí",
            profile: "Tu información de perfil",
            invoices: "Tu historial de facturas"
        }
    },
    theme: {
        light: "Claro",
        dark: "Oscuro",
        system: "Predeterminado del sistema"
    }
} as const;
